import API from "../../services/API";
import axios from "axios";
import Endpoints from "../config/Endpoints";

export default {

    Submit: function (crm, uf) {
        let url = API.url(
            Endpoints.CrmValidation.Submit,
            {
                crm: crm,
                uf: uf
            },
            true
        );

        return axios.post(url)
            .then((res) => {
                return res.data.status;
            });
    }

}
